import React from 'react';
import TextFieldMUI from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const borderColor = '#d5d5d5';
const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiInputBase-input': {
      fontWeight: 'bold',
      fontSize: '14px',
    },
    '& .MuiFormLabel-root': {
      color: 'black',
      fontSize: '14px',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: borderColor,
        borderRadius: '3px',
        boxShadow: '0 -3px 5px 0 rgba(0, 0, 0, 0.16)',
        border: `solid 1px ${borderColor}`,
      },
      '&.Mui-focused fieldset': {
        borderColor: borderColor,
      },
      '&:hover fieldset': {
        borderColor: borderColor,
      },
    },
  },
}));

function TextField(props) {
  const classes = useStyles();

  return (
    <TextFieldMUI className={classes.root} variant="outlined" {...props} />
  );
}

export default TextField;
